<div class="card p-0 border-none">
    <p-toolbar styleClass="mb-4 gap-2 surface-50 border-none border-round-xl">
        <ng-template pTemplate="left">
            <div class="flex gap-2">
                <p-button severity="success" label="Nuevo Pedido/Despacho" icon="pi pi-plus" size="small" (onClick)="openTransferForm('create')"></p-button>
            </div>
        </ng-template>

        <ng-template pTemplate="right">
            <div class="flex gap-2">
                <p-dropdown [options]="directionOptions" [ngModel]="directionFilter()" (ngModelChange)="directionFilter.set($event)" placeholder="Dirección" styleClass="w-full"></p-dropdown>
                <p-dropdown [options]="statusOptions" [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)" placeholder="Estado" styleClass="w-full"></p-dropdown>
                <p-button icon="pi pi-refresh" (onClick)="loadData()" [loading]="loading()" severity="secondary" [text]="true" [rounded]="true"></p-button>
            </div>
        </ng-template>
    </p-toolbar>

    <p-table #dt [value]="data()" [loading]="loading()"
             styleClass="p-datatable-sm" [rowHover]="true"
             responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th>Código</th>
                <th>Fecha</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Artículos</th>
                <th>Estado</th>
                <th style="width: 5rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-transfer>
            <tr>
                <td class="font-medium">TR-{{ transfer.transfer_code }}</td>
                <td>{{ transfer.createdAt | date:'short' }}</td>
                <td>{{ getBranchName(transfer.sourceBranchId) }}</td>
                <td>{{ getBranchName(transfer.targetBranchId) }}</td>
                <td>{{ transfer.items?.length || 0 }} ítem(s)</td>
                <td>
                    <p-tag [value]="getStatusName(transfer.status)" [severity]="getSeverity(transfer.status)"></p-tag>
                </td>
                <td>
                    <div class="flex gap-2">
                        <p-button icon="pi pi-eye" severity="secondary" [text]="true" [rounded]="true" size="small" pTooltip="Ver Detalle" (onClick)="openTransferForm('view', transfer.id)"></p-button>
                        <p-button *ngIf="transfer.status === 'PENDING' && (!branchId() || transfer.sourceBranchId === branchId())" icon="pi pi-send" severity="warning" [text]="true" [rounded]="true" size="small" pTooltip="Aprobar y Despachar" (onClick)="openTransferForm('approve', transfer.id)"></p-button>
                        <p-button *ngIf="transfer.status === 'IN_TRANSIT' && (!branchId() || transfer.targetBranchId === branchId())" icon="pi pi-download" severity="info" [text]="true" [rounded]="true" size="small" pTooltip="Confirmar Recepción" (onClick)="openTransferForm('receive', transfer.id)"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center p-4">
                    <div class="flex flex-column align-items-center justify-content-center text-500">
                        <i class="pi pi-inbox text-4xl mb-3"></i>
                        <span>No se encontraron transferencias.</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
